@if (!working && items.length) {
  <div>
    <div class="p-inputgroup">
      @if (!isArray(label)) {
        <div class="p-inputgroup-addon">{{label}}</div>
      }
      @if (isArray(label)) {
        <p-select class="p-inputgroup-addon-select"
          [options]="labels"
          [(ngModel)]="selectedLabel"
          appendTo="body"
          (ngModelChange)="emitChange()">
        </p-select>
      }
      @if (items.length >= 2) {
        <p-splitButton
          [label]="items[0]?.label"
          [icon]="items[0]?.icon"
          (onClick)="items[0]?.command({})"
          [model]="items">
        </p-splitButton>
      }
      @if (items.length == 1) {
        <p-button
          [label]="items[0]?.label"
          (onClick)="items[0]?.command({})">
        </p-button>
      }
      @if (hasTemplateDownload) {
        <p-button
          label="Template"
          [ariaLabel]="downloadingTemplate ? 'Downloading template' : 'Download template'"
          [icon]="downloadingTemplate ? 'pi pi-spinner pi-spin' : 'pi pi-download'"
          [disabled]="downloadingTemplate"
          severity="secondary"
          (onClick)="downloadTemplate()">
        </p-button>
      }
    </div>
  </div>
}
@if (working) {
  <div>
    <button pButton class="p-button-nonbutton" disabled="true" label="Uploading..." icon="pi pi-spinner pi-spin"></button>
  </div>
}
<form style="display: none;">
  <input type="file" #fileInput [accept]="getFileFormats()" (change)="startUpload()" />
</form>
